import { AccountRole } from "@common/types/domains/accounting/account";

export type NativeInvoiceAdjustmentKind = "tax" | "discount" | "deposit";

export const NATIVE_INVOICE_ADJUSTMENT_DEFAULT_ACCOUNT_ROLES: Record<
    NativeInvoiceAdjustmentKind,
    AccountRole
> = {
    tax: AccountRole.salesTaxPayable,
    discount: AccountRole.discountsAndAllowances,
    deposit: AccountRole.customerDeposits,
};

export const NATIVE_INVOICE_ADJUSTMENT_DEFAULT_RECEIVABLES_ROLE =
    AccountRole.accountsReceivable;
